import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone';
import { pick } from 'lodash';

import axios from 'axios';

import InputDropzoneDisplay from './dropzoneDisplay';

const REGEX_EXTRACT_YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
const REGEX_EXTRACT_VIMEO_ID = /vimeo.*?([0-9]+$)/i;
const REGEX_EXTRACT_VIMEO_PREVIEW = /<thumbnail_large>(.*?)<\/thumbnail_large>/i;

const MODE_NEUTRAL = 'NEUTRAL';
const MODE_IMAGE = 'IMAGE';
const MODE_VIDEO_YOUTUBE = 'YOUTUBE';
const MODE_VIDEO_VIMEO = 'VIMEO';

export default class InputDropzoneVideo extends Component {
	static propTypes = {
		path: PropTypes.string.isRequired,
		disableClick: PropTypes.bool,
		multiple: PropTypes.bool,
		accept: PropTypes.string,
		mode: PropTypes.string,
		name: PropTypes.string.isRequired,
		preview: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.string,
			PropTypes.object,
		]).isRequired,
		caption: PropTypes.string,
		extraValue: PropTypes.object,
		changeId: PropTypes.func,
		params: PropTypes.object,
	};

	static defaultProps = {
		disableClick: false,
		multiple: false,
		accept: '',
		preview: '',
		name: '',
		caption: '',
		mode: '',
		changeId: () => {},
		extraValue: {},
		params: {},
	};

	constructor(props) {
		super();

		this.mounted = true;
		let previewString = props.preview;
		let youtubeId = false;
		if (props.video && props.mode === MODE_VIDEO_YOUTUBE) {
			youtubeId = this.getYoutubeID(props.video)
			previewString = this.getYoutubePreview(youtubeId);
		}

		let vimeoId = false;
		if (props.video && props.mode === MODE_VIDEO_VIMEO) {
			vimeoId = this.getVimeoID(props.video);
			previewString = this.getVimeoPreview(vimeoId);
		}

		this.state = {
			mode: (
				props.mode === MODE_IMAGE ||
				props.mode === MODE_VIDEO_YOUTUBE ||
				props.mode === MODE_VIDEO_VIMEO
			) ? props.mode : MODE_NEUTRAL,
			value: props.caption || '',
			captionValue: props.caption || '',
			preview: previewString,
			youtube: youtubeId,
			vimeo:  vimeoId,
		};

		this.setValue(this.state, props);
	}

	componentWillReceiveProps(nextProps) {
		let newState = { ...this.state };

		// console.log(!nextProps.mode);
		if (nextProps.mode === MODE_IMAGE || !nextProps.mode) {
			let preview = nextProps.preview;
			if ((typeof nextProps.preview === 'object')) {
				let resolutions = Object.keys(nextProps.preview);
				let firstRes = nextProps.preview[resolutions[0]];
				if (typeof firstRes === 'object') {
					let spans = Object.keys(firstRes);
					let firstSpan = firstRes[spans[0]];

					if (firstSpan) {
						preview = firstSpan;
					}
				}
			}
			newState.preview = preview;
		}

		// if (this.props.name === 'visuals[3]') {
		// 	console.log('## UPDATE ##');
		// 	console.log(this.props.preview);
		// 	console.log(nextProps.preview);
		// 	console.log(newState.preview);
		// }

		if (nextProps.mode !== this.props.mode) {
			newState.mode = (
				nextProps.mode === MODE_IMAGE ||
				nextProps.mode === MODE_VIDEO_YOUTUBE ||
				nextProps.mode === MODE_VIDEO_VIMEO
			) ? nextProps.mode : MODE_NEUTRAL;

			if (nextProps.video) {
				if (nextProps.mode === MODE_VIDEO_YOUTUBE) {
					// console.log('YOUTUUUBE');
					const youtubeID = this.getYoutubeID(nextProps.video);

					newState = {
						...newState,
						preview: this.getYoutubePreview(youtubeID),
						youtube: youtubeID,
					}
				}

				if (nextProps.mode === MODE_VIDEO_VIMEO) {
					// console.log('VIIIIMEO');
					const vimeoID = this.getVimeoID(nextProps.video);

					newState = {
						...newState,
						preview: this.getYoutubePreview(vimeoID),
						vimeo: vimeoID,
					}
				}

				if (nextProps.mode === MODE_NEUTRAL) {
					newState.preview = '';
				}
			}
		}



		this.setValue(newState, nextProps);
		this.mounted && this.setState(newState);
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let className = 'form-dropzone-video pixel-pattern pixel-pattern--10';
		let { name } = this.props;
		let aspect = false;

		if (this.props.className) {
			className += ' ' + this.props.className;
		}



		// 487x280 >>         >> 290 x 167
		// 877x560 >> 522x326 >> 522 x 333
		//
		// aspect: ,624521073

		// multiplier: ,595210946
		//
		// 522 x 334
		// 290 x 167

		//console.log(preview);

		let placeholder = '...';
		let captionClass = 'form-dropzone-video__input__caption';
		let inputAction = () => {};

		switch (this.state.mode) {
			case MODE_NEUTRAL:
				inputAction = this.setVideoInput.bind(this);
				break;
			case MODE_IMAGE:
				placeholder = 'Add image caption (optional)';
				inputAction = this.setElementCaption.bind(this);
				captionClass += ' ' + captionClass + '--active';
				break;
			case MODE_VIDEO_YOUTUBE:
				placeholder = 'Add video caption (optional)';
				inputAction = this.setElementCaption.bind(this);
				captionClass += ' ' + captionClass + '--active';
				aspect = 0.75;
				break;
			case MODE_VIDEO_VIMEO:
				placeholder = 'Add video caption (optional)';
				inputAction = this.setElementCaption.bind(this);
				captionClass += ' ' + captionClass + '--active';
				aspect = 0.5625;
				break;
		}

		return (
			<div className={className}>
				<div className='form-dropzone-video__container'>
					<div className='form-dropzone-video__file'>
						<InputDropzoneDisplay key={name} {...this.props} preview={this.state.preview} aspect={aspect || this.props.aspect} onClear={() => this.onDropzoneClear()} onUpload={(res) => this.onDropzoneUpload(res)} params={this.props.params} />
					</div>
					<div className='cf'></div>
				</div>

				<div className='form-dropzone-video__input'>
					<input type='text' className={captionClass} value={this.state.captionValue} placeholder={placeholder} onChange={this.setElementCaption.bind(this)} />

					<input type='text' className='form-dropzone-video__input__video' value={this.state.value} placeholder='Or add youtube or vimeo url' onChange={this.setVideoInput.bind(this)} />
				</div>
			</div>
		);
	}

	onDropzoneClear() {
		this.setStateEnhanced({
			...this.state,
			mode: MODE_NEUTRAL,
			preview: '',
			youtube: false,
			vimeo: false,
			captionValue: '',
			value: '',
		}, this.props);

		let id = 0;
		if (this.props.extraValue) {
			id = (this.props.extraValue.id || this.props.extraValue.fid);
		}

		this.props.changeId(id, '');
	}

	onDropzoneUpload(res) {
		// console.log('UPLOAD HAPPND');
		this.setStateEnhanced({
			...this.state,
			mode: MODE_IMAGE,
			youtube: false,
			vimeo: false,
			captionValue: '',
			value: '',
		}, this.props);

		if (res && res.data && res.data.sectionId) {
			let preview = '';

			if (res.data.path) {
				preview = res.data.path;
			}

			this.props.changeId(res.data.sectionId, preview);
		}
	}

	setVideoInput(e) {
		let newValue = e.target.value;
		let youtubeID = this.getYoutubeID(newValue);
		let vimeoID = this.getVimeoID(newValue);

		let model = {
			...this.state,
			value: newValue,
			preview: '',
			youtube: false,
			vimeo: false,
		};

		if (youtubeID) {
			//console.log('## YOUTUBE VIDEO -- SET PREVIEW');
			this.setStateEnhanced({
				...model,
				mode: MODE_VIDEO_YOUTUBE,
				preview: this.getYoutubePreview(youtubeID),
				youtube: youtubeID,
				//value: '',
			}, this.props);
		} else if (vimeoID) {
			//console.log('## VIMEO VIDEO -- GETTING PREVIEW');
			this.getVimeoPreview(vimeoID, {
				...model,
				mode: MODE_VIDEO_VIMEO,
				vimeo: vimeoID,
				//value: '',
			});
		} else {
			this.setStateEnhanced(model, this.props);
		}
	}

	setElementCaption(e) {
		this.setStateEnhanced({
			...this.state,
			captionValue: e.target.value,
		}, this.props);
	}

	getYoutubeID(string) {
		let extracted = REGEX_EXTRACT_YT_ID.exec(string);

		if (extracted && extracted.length > 1) {
			return extracted[1];
		} else if (string.length >= 10 && string.length <= 12) {
			return string;
		}

		return false;
	}

	getYoutubePreview(youtubeID) {
		if (!youtubeID) {
			return '';
		}

		let previewUrl = `https://img.youtube.com/vi/${youtubeID}/hqdefault.jpg`;

		return previewUrl;
	}

	getVimeoID(string) {
		let extracted = REGEX_EXTRACT_VIMEO_ID.exec(string);

		if (extracted && extracted.length > 1) {
			return extracted[1];
		} else if (/^[0-9]*$/.exec(string)) {
			return string;
		}

		return false;
	}

	getVimeoPreview(vimeoID, model = {}) {
		if (!vimeoID || vimeoID === '0') {
			return '';
		}

		let thumbnailDataUrl = `https://vimeo.com/api/v2/video/${vimeoID}.xml`;

		axios.get(thumbnailDataUrl)
		.then((response) => {
			let extracted = REGEX_EXTRACT_VIMEO_PREVIEW.exec(response.data);
			if (extracted && extracted.length > 0) {
				//console.log('## VIMEO VIDEO -- SETTING PREVIEW');
				this.setStateEnhanced({
					...this.state,
					...model,
					preview: extracted[1],
				}, this.props);
			} else {
				//console.log('## VIMEO VIDEO -- NO PREVIEW');
				this.vimeoFail(model);
			}
		})
		.catch((response) => {
			//console.log('## VIMEO VIDEO -- FAIL PREVIEW');
			this.vimeoFail(model);
		});
	}

	vimeoFail(model) {
		this.setStateEnhanced({
			...model,
			preview: '',
		}, this.props);
	}

	setStateEnhanced(state, props) {
		this.mounted && this.setState(state);
		this.setValue(state, props);
	}

	setValue(state, props) {
		// console.log(props.extraValue);
		// console.log('SET VALUE ####');
		// console.log(props.extraValue);
		this.value = {
			...(pick(props.extraValue, 'id')),
			type: state.mode,
			caption: state.captionValue,
			youtube: state.youtube ? state.youtube : 0,
			vimeo: state.vimeo ? state.vimeo : 0,
		};
	}

}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/dropzone/dropzoneVideo.js
 **/